<template>
    <v-container>
        <v-card>
            <v-card-title class="yellow white--text">Reset Password</v-card-title>
            <v-card-text v-if="loggedIn">
                You are logged in. Reset only works if you are viewing anonymously.
            </v-card-text>

            <v-card-text class="mt-5" v-if="!loggedIn">
                <v-form
                        :lazy-validation="false"
                        ref="form"
                        v-model="formValid"
                >
                    <v-text-field
                            :rules="formRules.email"
                            @keydown="keyDownHandler"
                            id="email-field"
                            label="E-mail"
                            required
                            v-model="email"
                    ></v-text-field>

                    <v-text-field
                            :rules="formRules.password"
                            @keydown="keyDownHandler"
                            label="New Password"
                            required
                            type="password"
                            v-model="password"
                    ></v-text-field>

                    <v-text-field
                            :rules="formRules.passwordConfirm"
                            @keydown="keyDownHandler"
                            label="Confirm Password"
                            required
                            type="password"
                            v-model="passwordConfirmation"
                    ></v-text-field>

                    <v-btn
                            :disabled="!formValid || executing"
                            @click="submit"
                            class="mr-4 mt-3 white--text"
                            color="green"
                    >
                        Submit
                    </v-btn>
                </v-form>
            </v-card-text>

            <v-dialog max-width="290" persistent v-model="successDialog">
                <v-card>
                    <v-card-title class="yellow white--text">Success Message</v-card-title>
                    <v-card-text class="mt-5">
                        Your password has been changed.
                        Please use your new credentials to login.
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="$router.push('/login')" color="green darken-1" text>OK</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog max-width="290" persistent v-model="errorDialog">
                <v-card>
                    <v-card-title class="error white--text">Error</v-card-title>
                    <v-card-text>{{errorText}}</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="errorDialog = false" color="green darken-1" text>OK</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    </v-container>
</template>

<script>
    import api from "../services/aggrega8-api"

    export default {
        name: 'reset-password',

        computed: {
            executing: function () {
                return this.$store.state.executing
            },
            loggedIn: function () {
                return this.$store.state.loggedIn
            }
        },
        data() {
            return {
                formValid: true,
                errorDialog: false,
                errorText: "",
                successDialog: false,
                token: this.$route.params.token,
                email: '',
                password: '',
                passwordConfirmation: '',
                formRules: {
                    email: [
                        v => !!v || 'E-mail is required',
                        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                    ],
                    password: [
                        v => !!v || 'New password is required',
                        v => {
                            let error = ''
                            error += (v && v.length < 8 && 'be at least 8 characters') || ''
                            error += (!v.match("(.*)[0-9](.*)") && ((error != '' && ', ') || '') + 'contain at least one number') || ''
                            error += (!v.match("^(.*)[a-z](.*)") && ((error != '' && ', ') || '') + 'contain at least one lowercase character') || ''
                            error += (!v.match("^(.*)[A-Z](.*)") && ((error != '' && ', ') || '') + 'contain at least one uppercase character') || ''
                            error += (!v.match("(.*)[^a-zA-Z0-9](.*)") && ((error != '' && ', ') || '') + 'contain at least one symbol') || ''
                            return (error != '') ? 'Password must ' + error : true
                        }
                    ],
                    passwordConfirm: [
                        v => !!v || 'Password Confirmation is required',
                        v => v == this.password || 'Password Confirmation must match'
                    ],

                },
                lazy: false,
            }
        },
        methods: {
            keyDownHandler(k) {
                if (k.keyCode !== 13) return
                if (!this.valid) {
                    return
                }
                this.submit()
            },
            validate() {
                if (this.$refs.form.validate()) {
                    this.snackbar = true
                }
            },
            submit() {
                this.$store.dispatch("setExecuting", true)
                api.post("/public/resetpassword", {
                    user: this.email,
                    password: this.password,
                    token: this.token
                    }).then(
                () => {
                    this.successDialog = true
                },
                (error) => {
                    console.log(error.response.status)
                    this.errorText = "Invalid user or reset token"
                    this.errorDialog = true
                }).then(() => {
                    this.$store.dispatch("setExecuting", false)
                })
            }
        }
    }
</script>
